/** Lowercase alphanumeric slug (non-alphanumerics → underscore). For filenames etc. */
export function slugify(value: string): string {
  return value.replace(/[^a-z0-9]/gi, "_").toLowerCase();
}
